import { designTokens } from '@monorepo/nova-ui';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: theme.customShape.borderRadius5XL,
    padding: theme.spacing(12),
    width: '100%',
    maxWidth: theme.spacing(130),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8, 6),
      maxWidth: theme.spacing(79),
    },
  },
}));

export const StyledDialogContent = styled(DialogContent)({
  padding: 0,
  position: 'relative',
  overflow: 'visible',
});

export const StyledLanguageSelectorContainer = styled(Box)({
  position: 'absolute',
  top: 0,
  right: 0,
  '& > *': {
    marginTop: 0,
    marginBottom: 0,
  },
});

export const StyledErrorText = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.error.main,
  marginTop: theme.spacing(1),
}));

export const StyledButtonRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(6),
}));

export const StyledStepTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h4,
  fontWeight: designTokens.typography.fontWeights.bold,
}));

export const StyledEmailIconWrapper = styled(Stack)(({ theme }) => ({
  width: theme.spacing(30),
  height: theme.spacing(30),
  borderRadius: theme.customShape.borderRadiusLarge,
  overflow: 'hidden',
}));

export const StyledPillTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    height: theme.spacing(12),
    borderRadius: theme.customShape.borderRadiusFull,
    '& input': {
      ...theme.typography.body1,
      color: theme.palette.text.primary,
      paddingInline: theme.spacing(4),
      '&::placeholder': {
        color: theme.palette.text.secondary,
        opacity: 1,
      },
    },
  },
  '& .MuiFormHelperText-root': {
    ...theme.typography.caption,
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
}));

export const StyledPillButton = styled(Button)(({ theme }) => ({
  minHeight: theme.spacing(12),
  borderRadius: theme.customShape.borderRadiusFull,
  flex: 1,
}));

export const StyledStepContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: theme.spacing(107.5),
}));

export const StyledOtpFooter = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(3),
  gap: theme.spacing(0.5),
  alignItems: 'center',
}));

export const StyledFooterText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  textAlign: 'center',
}));

interface StyledResendLinkProps {
  disabled?: boolean;
}

export const StyledResendLink = styled('span', {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<StyledResendLinkProps>(({ theme, disabled }) => ({
  textDecoration: 'underline',
  cursor: disabled ? 'default' : 'pointer',
  color: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
  pointerEvents: disabled ? 'none' : 'auto',
  '&:hover': {
    opacity: disabled ? 1 : 0.8,
  },
}));
